import Vue                 from 'vue';
import Icons               from './vue/Components/Icons/Icons';
import Modal               from './vue/Components/Modal';
import VideoPlaylist       from './vue/Components/VideoPlaylist';
import RotatorTestimonials from './vue/Components/RotatorTestimonials';
import RotatorImages       from './vue/Components/RotatorImages';
import Career              from './vue/Components/Career';
import VideoModal          from "./vue/Components/VideoModal";
import Calendar            from "./vue/Components/Calendar";

new Vue({
    el        : '#app',
    components: {
        Icons,
        Modal,
        VideoPlaylist,
        RotatorTestimonials,
        RotatorImages,
        Career,
		VideoModal,
		Calendar,
    }
});
